import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Checkbox,
  Container,
  FormControlLabel,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { FieldValues, UseFormRegister } from 'react-hook-form';

import imgAwsAhnlabCloudLogo from 'assets/aws-ahnlab-cloud-logo.svg';
import imgSmartNurseLogoGlobal from 'assets/smart-nurse-logo-global.svg';
import Form from 'components/Form';
import MuiDialog from 'components/MuiDialog';

import theme from 'styles/theme';

import ConfirmButton from './components/ConfirmButton';
import PWConfirmButton from './components/PWConfirmButton';

interface Props {
  errors: { [x: string]: any };
  register: UseFormRegister<FieldValues>;
  onSignUp: () => void;
}

function SignInForm({ errors, register, onSignUp }: Props) {
  const { palette } = useTheme();

  return (
    <Box>
      <Container maxWidth="sm" sx={{ mt: 10, mb: 6 }}>
        <Card
          elevation={1}
          sx={{ borderTop: `solid 8px ${palette.primary.dark}` }}
        >
          <CardMedia
            height={120}
            component="img"
            image={imgSmartNurseLogoGlobal}
            sx={{ objectFit: 'contain', mt: 5, mb: 5 }}
          />
          <CardContent
            sx={{ width: '100%', textAlign: 'center', padding: '0 0 40px 0' }}
          >
            <Typography>Together with the realistic patient data</Typography>
            <Typography sx={{ color: `${theme.palette.primary.dark}` }}>
              Experience the best hospital Record System!
            </Typography>
          </CardContent>
          <CardContent sx={{ ml: 5, mr: 5 }}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              variant="outlined"
              sx={{ mb: 2.5 }}
              error={Boolean(errors.userEmail)}
              helperText={errors.userEmail?.message}
              {...register('userEmail', {
                required: 'Vui lòng nhập địa chỉ Email',
              })}
            />
            <Form.Password
              fullWidth
              label="Mật khẩu"
              sx={{ mb: 0.25 }}
              error={Boolean(errors.userPassword)}
              helperText={errors.userPassword?.message}
              {...register('userPassword', {
                required: 'Vui lòng nhập mật khẩu',
              })}
            />
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked
                  {...register('saveEmail')}
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
              label="Lưu địa chỉ Email"
            />
          </CardContent>
          <CardActions sx={{ ml: 5, mr: 5, pb: 5 }}>
            <Box flex={1} textAlign="center">
              <Button
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                sx={{ mb: 2.5 }}
              >
                Đăng nhập
              </Button>
              <Button
                fullWidth
                variant="outlined"
                size="large"
                sx={{
                  mb: 2.5,
                  backgroundColor: 'white',
                  color: '#2D73DC',
                  border: '1px solid #2D73DC',
                }}
                onClick={onSignUp}
              >
                Đăng ký
              </Button>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '10px',
                  justifyContent: 'center',
                }}
              >
                <ConfirmButton title="Quên Email" color={'black'} />
                <Typography sx={{ lineHeight: '28px', fontSize: '12px' }}>
                  {' | '}
                </Typography>
                <PWConfirmButton title="Quên mật khẩu" color={'black'} />
              </Box>
              <Button
                fullWidth
                size="large"
                variant="outlined"
                sx={{
                  mt: 2,
                  mb: 2.5,
                  backgroundColor: 'white',
                  color: '#2D73DC',
                  border: '1px solid #2D73DC',
                }}
                onClick={() =>
                  window.open(
                    'https://www.notion.so/smartnurse/H-ng-d-n-s-d-ng-Smart-ENR-8a109f938ad44de792848aa9babb9686?pvs=4'
                  )
                }
              >
                Smart ENR thủ công
              </Button>

              <Typography sx={{ fontSize: '0.8125rem' }}>
                Liên hệ : nurse@smartnurse.co.kr
              </Typography>
            </Box>
          </CardActions>

          <Typography fontSize={10} align="center" sx={{ mb: 2 }}>
            Copyright © 2022-2026 DKMediInfo. All rights reserved.
          </Typography>

          <CardMedia
            height={23}
            component="img"
            image={imgAwsAhnlabCloudLogo}
            sx={{ objectFit: 'contain', mb: 4 }}
          />
        </Card>
      </Container>
    </Box>
  );
}

export default SignInForm;
